import { Navigate, useLocation } from "react-router-dom";
import AppBootLoader from "@/components/app/AppBootLoader";
import { useAuth } from "@/contexts/AuthContext";

interface RequireAuthProps {
  children: React.ReactNode;
}

const RequireAuth = ({ children }: RequireAuthProps) => {
  const { currentUser, isLoading } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return <AppBootLoader />;
  }

  if (!currentUser) {
    // Redirige al login y recuerda a donde queria ir el usuario.
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (currentUser.status === "pending_age_declaration") {
    return <Navigate to="/age-declaration" state={{ from: location }} replace />;
  }

  return <div className="contents">{children}</div>;
};

export default RequireAuth;
